import React from 'react';
import { NotificationPreferences } from '../../../../../../../__generated__/loma';
import DisclaimerText from '../DisclaimerText';
import PanelContentHeader from '../../../../ui/PanelContentHeader/PanelContentHeader';
import { LayoutTree } from '../../../DynamicLayout';
import { Channels } from '../../types';
import styles from './OptinTemplate.module.css';

const { FeatureLayout } = LayoutTree;

export interface OptInChannelProps {
  optInChannelInput: React.ReactNode;
  optInIcon: React.ReactNode;
  optInMessageText: string;
  landscapeColWidths?: [number, number];
}

export interface OptInTemplateProps {
  featureName?: string;
  layout?: LayoutTree.FeatureLayout;
  channel: Channels;
  notificationPreferencesState?: NotificationPreferences;
  optInChannelProps: OptInChannelProps;
  consumerPreferencesOptinEnabled?: boolean;
}

const OptInTemplate: React.FunctionComponent<OptInTemplateProps> = ({
  featureName,
  layout,
  channel,
  notificationPreferencesState,
  optInChannelProps: {
    optInIcon,
    optInMessageText,
    optInChannelInput,
    landscapeColWidths,
  },
  consumerPreferencesOptinEnabled,
}) => {
  const isLandscape = layout === FeatureLayout.LANDSCAPE;

  return (
    <div
      className={styles.optinContainer}
      data-test={`${channel}NotificationCenterOptIn`}
    >
      <div
        data-testid={`column-one-${isLandscape ? '6' : '12'}`}
        style={{
          gridColumn: `span ${
            isLandscape
              ? ((landscapeColWidths && landscapeColWidths[0]) ?? '6')
              : '12'
          }`,
        }}
      >
        <div
          className={
            isLandscape ? styles.panelContainerLandscape : styles.panelContainer
          }
        >
          <PanelContentHeader
            as="p"
            featureName={featureName}
            icon={optInIcon}
            headerText={optInMessageText || ''}
            isLandscape={isLandscape}
          />
        </div>
        {isLandscape && !consumerPreferencesOptinEnabled && (
          <div
            className={styles.disclaimerContainerLandscape}
            data-test={`${channel}DisclaimerTextContainer`}
          >
            <DisclaimerText
              notificationChannel={channel}
              notificationPreferencesState={notificationPreferencesState}
              consumerPreferencesOptinEnabled={consumerPreferencesOptinEnabled}
            />
          </div>
        )}
      </div>
      <div
        data-testid={`column-two-${isLandscape ? '6' : '12'}`}
        style={{
          gridColumn: `span ${
            isLandscape
              ? ((landscapeColWidths && landscapeColWidths[0]) ?? '6')
              : '12'
          }`,
        }}
      >
        <div
          className={
            isLandscape ? styles.inputContainerLandscape : styles.inputContainer
          }
        >
          {optInChannelInput}
        </div>
      </div>
      {!isLandscape && !consumerPreferencesOptinEnabled && (
        <div
          className={styles.disclaimerContainer}
          data-test={`${channel}DisclaimerTextContainer`}
        >
          <DisclaimerText
            notificationChannel={channel}
            notificationPreferencesState={notificationPreferencesState}
            consumerPreferencesOptinEnabled={consumerPreferencesOptinEnabled}
          />
        </div>
      )}
    </div>
  );
};

export default OptInTemplate;
